import helpers from '../../helpers';

// ----------------------------------------------------------------------------
// PROMISES
// ----------------------------------------------------------------------------
/* */
const parseItem = (item) => {
    if (!item) return null;
    const { ext, name } = helpers.string.fileInfo(item.filename);

    return {
        ...item,
        ext,
        name: item.name || name,
    };
};

export default parseItem;
